<template>
  <h4 class="text-left mb-2">First, download supplier list template</h4>
  <PPrimaryButton appkit-icon="icon-download-outline" :href="downloadPathXlsx">
    Download supplier list template (.xlsx)
  </PPrimaryButton>
  <p class="mt-1"><a :href="downloadPathCsv" class="download-link appkit-tooltip">Download .csv template instead</a></p>
</template>

<script setup lang="ts">
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import { computed } from "vue";

const props = defineProps<{
  downloadCustomerTemplate: boolean;
}>();

const downloadPathXlsx = computed(() =>
  props.downloadCustomerTemplate
    ? "/static/supplier-template-customer.xlsx"
    : "/static/supplier-template-supplier.xlsx"
);

const downloadPathCsv = computed(() =>
  props.downloadCustomerTemplate
    ? "/static/supplier-template-customer.csv"
    : "/static/supplier-template-supplier.csv"
);

</script>

<style scoped lang="scss">
.download-link {
  color: var(--grey);
}
</style>
